const opts = {
  filterable: true,
  sortable: false
};
const CONSTANTS = {
  HIGH_TEMP: 'highTemp',
  GPS_INOPERATIVE: 'gpsInoperative',
  LOW_BATTERY: 'lowBattery',
  LOW_VOLTAGE: 'lowVoltage'
};
const alertLabels = () => ({
  [CONSTANTS.HIGH_TEMP]: 'High Temperature',
  [CONSTANTS.GPS_INOPERATIVE]: 'GPS Inoperative',
  [CONSTANTS.LOW_BATTERY]: 'Low Battery',
  [CONSTANTS.LOW_VOLTAGE]: 'Low Voltage'
});
const alertVariants = {
  [CONSTANTS.HIGH_TEMP]: 'pillWarning',
  [CONSTANTS.GPS_INOPERATIVE]: 'pillWarning',
  [CONSTANTS.LOW_BATTERY]: 'pillWarning',
  [CONSTANTS.LOW_VOLTAGE]: 'pillWarning'
};
export default {
  id: 'locator.deviceHealth',
  name: 'locator.deviceHealth',
  displayName: 'Device Health',
  valueType: 'string',
  objectType: 'locator',
  blueprint: {},
  getOption: key => {
    return opts[key];
  },
  get: obj => {
    const toReturn = [];
    const deviceHealth = obj?.data?.deviceHealth || {};
    Object.keys(deviceHealth).forEach(key => {
      // make sure the key has a true value in collections map
      if (deviceHealth[key]) {
        toReturn.push(key);
      }
    });
    return toReturn;
  }
};
export { alertLabels, alertVariants, CONSTANTS };